
export const activatedOption = [

    { label: '全部', value: null },
    { label: '已激活', value: '1' },
    { label: '未激活', value: '0' },
];


export default { activatedOption };


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/options.ts